__turbopack_context__.v({
  "empty": "WindowAreaView-module__9c98bW__empty",
  "root": "WindowAreaView-module__9c98bW__root",
  "window": "WindowAreaView-module__9c98bW__window",
  "windowMissing": "WindowAreaView-module__9c98bW__windowMissing",
});
